export enum BootKeys {
    TranscriptAssociated = "TranscriptAssociated",
    AudioBackupState = "AudioBackupState",
    DurationSeconds = "DurationSeconds",
    IsFreemiumUpsellEnabled = "IsFreemiumUpsellEnabled",
    IsLicensedUser = "IsLicensedUser",
    IsCopilotLicensedUser = "IsCopilotLicensedUser",
    TranscriptionSessionId = "TranscriptionSessionId",
    IsCopilotLicensedCheckEnabled = "IsCopilotLicensedCheckEnabled",
    TranscriptionPaneBuildNumber = "TranscriptionPaneBuildNumber",
    DidBootFinishSuccessfully = "DidBootFinishSuccessfully",
    InitialTranscriptionRoutePathName = "InitialTranscriptionRoutePathName",
    SDXPackageVersion = "SDXPackageVersion",

    // Durations for asynchronous tasks
    LoadTranscriptionStringsDuration = "LoadTranscriptionStringsDuration",
    InitializeBackupStateDuration = "InitializeBackupStateDuration",
    SetInitialPageFromBackupStateAndStoredTranscriptionDuration = "SetInitialPageFromBackupStateAndStoredTranscriptionDuration",

    // Durations for sequential boot stages
    InitializeBootStageDuration = "InitializeBootStageDuration",
    InitializeAsyncTasksStageDuration = "InitializeAsyncTasksStageDuration",
    ExecuteSynchronousTasksStageDuration = "ExecuteSynchronousTasksStageDuration",
    WaitForAsyncTasksStageDuration = "WaitForAsyncTasksStageDuration",
    FinalizeBootStageDuration = "FinalizeBootStageDuration",
    UnlimitedMinsActive = "UnlimitedMinsActive",
    ALSessionInitRetryEnabled = "ALSessionInitRetryEnabled",
    HostAppSettingsJSON = "HostAppSettingsJSON",

    // Additional Keys to be used in HostAppSettingsJSON
    IsUnlimitedFileUploadMinutesAvailableForTenant = "IsUnlimitedFileUploadMinutesAvailableForTenant",

    // OneNote Specific Key
    IsOneNoteNotebookIdentityEmpty = "IsOneNoteNotebookIdentityEmpty",
    IsAccountSwitchDialogShown = "IsAccountSwitchDialogShown"
};